import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { physicianOperation } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { OPERATION_HOUR } from "../redux/Slices/AuthSlice";

const DaySelector = ({ toke = null, page = null }) => {
	// State for selected days and times
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [selectedDays, setSelectedDays] = useState([]);
	const [disabledDays, setDisabledDays] = useState([]);
	const [timeSlots, setTimeSlots] = useState({});
	const token = useSelector((state) => state?.Auth?.token);
	const [loading, setLoading] = useState(false);

	// List of days
	const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

	const Physcialtimming = useSelector((state) => state?.Auth?.operation);

	// Handle day selection
	const handleDayClick = (day) => {
		setDisabledDays([...disabledDays, day]);
		setSelectedDays([...selectedDays, day]);
		console.log(timeSlots);
	};

	useEffect(() => {
		return () => {
			setSelectedDays([]);
			setDisabledDays([]);
			setTimeSlots({});
		};
	}, []);

	// Handle time selection
	const handleTimeChange = (day, field, value) => {
		setTimeSlots({
			...timeSlots,
			[day]: {
				...timeSlots[day],
				[field]: value,
			},
		});
	};

	// Handle removing a selected day
	const handleRemoveDay = (day) => {
		setSelectedDays(selectedDays.filter((d) => d !== day));
		setDisabledDays(disabledDays.filter((d) => d !== day));
		const newTimeSlots = { ...timeSlots };
		delete newTimeSlots[day];
		setTimeSlots(newTimeSlots);
	};

	// Render time select boxes when a day is selected
	const renderTimeSelect = (day) => (
		<div key={day} className="time-select">
			<div className="row">
				<div className="col-md-2">
					{" "}
					<span className="dayName">{day}:</span>
				</div>
				<div className="col-md-4">
					<input
						type="time"
						placeholder="Start time"
						value={timeSlots[day]?.start || ""}
						onChange={(e) => handleTimeChange(day, "start", e.target.value)}
					/>
				</div>
				<div className="col-md-4">
					<input
						type="time"
						placeholder="End time"
						value={timeSlots[day]?.end || ""}
						onChange={(e) => handleTimeChange(day, "end", e.target.value)}
					/>
				</div>
				<div className="col-md-2">
					<div className="close-dv">
						<i
							onClick={() => handleRemoveDay(day)}
							className="fa fa-times"
							aria-hidden="true"
						></i>
					</div>
				</div>
			</div>
		</div>
	);

	// Send Payload Function
	const sendPayload = (e) => {
		e.preventDefault();
		setLoading(true);

		if (!selectedDays.length > 0) {
			Swal.fire({
				icon: "error",
				text: "Kindly Select Day and Time",
			});
			setLoading(false);
			return;
		}
		// Validate each selected day for missing start or end time
		for (let day of selectedDays) {
			if (!timeSlots[day]?.start || !timeSlots[day]?.end) {
				Swal.fire({
					icon: "error",
					text: "Kindly select both start and end time for all selected days",
				});
				setLoading(false);
				return;
			}
		}
		// Create payload
		const payload = selectedDays.map((day) => ({
			day,
			start_time: timeSlots[day]?.start,
			end_time: timeSlots[day]?.end,
		}));

		const data = {
			schedule: payload,
		};
		// Call the API
		physicianOperation(data, toke !== null ? toke : token)
			.then((res) => {
				dispatch(OPERATION_HOUR(res?.data?.operationHour));
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Your time has been Added",
					showConfirmButton: false,
					timer: 1500,
				});
				if (toke) {
					navigate("/sign-in");
				} else {
					navigate("/physician-time");
				}

				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				Swal.fire({
					icon: "error",
					text: "An error occurred while adding your schedule. Please try again.",
				});
			});
	};
	// ====================

	// useEffect(() => {
	//   setTimeout(() => {
	//     let daysArray = Physcialtimming.map((item) => item.day);
	//     setSelectedDays(daysArray);
	//     setDisabledDays(daysArray);

	//     let updatedSlots = {};

	//     daysArray.forEach((day) => {
	//       let slot = Physcialtimming.find((time) => time.day === day);
	//       if (slot) {
	//         updatedSlots[day] = {
	//           ...(updatedSlots[day] || {}),
	//           start: slot.start_time,
	//           end: slot.end_time
	//         };
	//       }
	//     });

	//     setTimeSlots((prevSlots) => ({
	//       ...prevSlots,
	//       ...updatedSlots
	//     }));
	//   }, 1000);
	// }, []);

	useEffect(() => {
		setTimeout(() => {
			let daysArray = Array.isArray(Physcialtimming)
				? Physcialtimming.map((item) => item.day)
				: [];

			setSelectedDays(daysArray);
			setDisabledDays(daysArray);

			let updatedSlots = {};

			daysArray.forEach((day) => {
				let slot = Physcialtimming.find((time) => time.day === day);
				if (slot) {
					updatedSlots[day] = {
						start: slot.start_time,
						end: slot.end_time,
					};
				}
			});

			setTimeSlots((prevSlots) => ({
				...prevSlots,
				...updatedSlots,
			}));
		}, 1000);
	}, []);

	return (
		<div className="day-selector">
			<div className="buttons">
				{days.map((day) => (
					<button
						key={day}
						onClick={() => handleDayClick(day)}
						disabled={disabledDays.includes(day)}
					>
						{day}
					</button>
				))}
			</div>

			<div className="time-selectors mt-3">
				{selectedDays.length > 0 ? (
					<>
						<div className="row">
							<div className="col-md-2 text-center">
								<div className="selected_day">
									<h5 className="main-heading-font dark-color level-6 mb-2 text-center">
										Day
									</h5>
								</div>
							</div>
							<div className="col-md-4">
								<div className="selected_day">
									<h5 className="main-heading-font dark-color level-6 mb-2 text-center">
										Start time
									</h5>
								</div>
							</div>
							<div className="col-md-4">
								<div className="selected_day">
									<h5 className="main-heading-font dark-color level-6 mb-2 text-center">
										End time
									</h5>
								</div>
							</div>
						</div>
					</>
				) : null}
				{selectedDays.map((day) => renderTimeSelect(day))}
			</div>

			<div className="row btn_row">
				<div className="col-lg-12">
					<Link className="btn wrapper-btn-main w-100 log-in mt-4 level-7 primary-regular-font text-decoration-none">
						<span
							onClick={(e) => sendPayload(e)}
							className="loading-btn loading bg-wrapper w-100"
						>
							{loading ? <i className="fa fa-spinner"></i> : "Submit"}
						</span>
					</Link>
				</div>
			</div>
		</div>
	);
};
export default DaySelector;
